import React from "react";
import { useHasSaleyardOrDeploymentPermission } from "hooks";
import {
  DeploymentPermissions,
  SaleyardPermissions,
} from "constants/permissions";
import { MLAMissingFieldsIndicator } from "./MlaMissingFieldsIndicator";
import { NASMissingFieldsIndicator } from "./NasMissingFieldsIndicator";
import { CombinedMissingFieldIndicatorProps } from "./types";

export const CombinedMissingFieldIndicator: React.FC<
  CombinedMissingFieldIndicatorProps
> = ({ modelIds, onlyAdvancedFields = false }) => {
  // Check if NAS indicators will be shown (Nutrien users)
  const hasDentitionPermission = useHasSaleyardOrDeploymentPermission(
    DeploymentPermissions.featureDentition,
    SaleyardPermissions.featureDentition,
  );
  const hasWeightRangePermission = useHasSaleyardOrDeploymentPermission(
    DeploymentPermissions.featureWeightRange,
    SaleyardPermissions.featureWeightRange,
  );

  const showNASIndicator =
    !onlyAdvancedFields && hasDentitionPermission && hasWeightRangePermission;

  return (
    <>
      <NASMissingFieldsIndicator
        keyValue={modelIds}
        onlyAdvancedFields={onlyAdvancedFields}
      />
      {/* Only show MLA/Data indicator if NAS indicator is not being shown */}
      {!showNASIndicator && <MLAMissingFieldsIndicator keyValue={modelIds} />}
    </>
  );
};
